import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Privacy", path: "/privacy" },
    { name: "Termini", path: "/terms" },
    { name: "Community", path: "/community" },
    { name: "Supporto", path: "/support" },
  ];

  return (
    <nav 
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0f]/80 backdrop-blur-xl border-b border-purple-500/10"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            data-testid="navbar-logo"
            className="flex items-center gap-3 group"
          >
            <img 
              src="/nerbys-logo.png" 
              alt="Nerbys Logo" 
              className="w-10 h-10 rounded-xl group-hover:scale-110 transition-transform"
            />
            <span className="font-extrabold text-2xl tracking-tight text-white">
              Nerbys
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "text-purple-400"
                    : "text-purple-200/60 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://apps.apple.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-download-btn"
              className="bg-gradient-to-r from-purple-600 to-purple-500 text-white px-6 py-2.5 rounded-full font-semibold text-sm hover:shadow-lg hover:shadow-purple-500/30 transition-all hover:scale-105 active:scale-95"
            >
              Scarica App
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-white"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {isOpen && (
          <div 
            data-testid="mobile-menu"
            className="md:hidden py-4 border-t border-purple-500/10"
          >
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block py-3 text-lg font-medium ${
                  location.pathname === link.path
                    ? "text-purple-400"
                    : "text-purple-200/60"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://apps.apple.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-4 bg-gradient-to-r from-purple-600 to-purple-500 text-white px-6 py-3 rounded-full font-semibold text-center"
            >
              Scarica App
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
